export var MerchantOverrides = {
  BorderRadius: {
    ModalDefault: 4,
    PaginationDefault: 4
  },
  Colors: {
    ButtonFabBackground: 'SystemWhite',
    ButtonFabBackgroundDisabled: 'SystemGrey0',
    ButtonFabBackgroundHovered: 'SystemGrey0',
    ButtonFabBackgroundPressed: 'SystemGrey5',
    ButtonFabForeground: 'SystemBlack',
    ButtonFabForegroundDisabled: 'SystemGrey30',
    ButtonFlatPrimaryBackground: 'SystemWhite',
    ButtonFlatPrimaryBackgroundDisabled: 'SystemGrey0',
    ButtonFlatPrimaryBackgroundHovered: 'SystemGrey5',
    ButtonFlatPrimaryBackgroundPressed: 'SystemGrey5',
    ButtonFlatPrimaryForeground: 'SystemBlue60',
    ButtonFlatPrimaryForegroundDisabled: 'SystemGrey30',
    ButtonFlatSecondaryBackground: 'SystemWhite',
    ButtonFlatSecondaryBackgroundDisabled: 'SystemGrey0',
    ButtonFlatSecondaryBackgroundHovered: 'SystemGrey5',
    ButtonFlatSecondaryBackgroundPressed: 'SystemGrey5',
    ButtonFlatSecondaryForeground: 'SystemBlue60',
    ButtonFlatSecondaryForegroundDisabled: 'SystemGrey30',
    ButtonPrimaryBackground: 'SystemBlue60',
    ButtonPrimaryBackgroundDisabled: 'SystemGrey0',
    ButtonPrimaryBackgroundHovered: 'SystemBlue70',
    ButtonPrimaryBackgroundPressed: 'SystemBlue80',
    ButtonPrimaryForeground: 'SystemWhite',
    ButtonPrimaryForegroundDisabled: 'SystemGrey30',
    ButtonPrimaryToggleBackground: 'SystemBlue5',
    ButtonPrimaryToggleBackgroundHovered: 'SystemBlue10',
    ButtonPrimaryToggleBackgroundPressed: 'SystemBlue20',
    ButtonPrimaryToggleBackgroundDisabled: 'SystemBlue0',
    ButtonPrimaryToggleBorder: 'SystemBlue40',
    ButtonPrimaryToggleBorderHovered: 'SystemBlue40',
    ButtonPrimaryToggleBorderPressed: 'SystemBlue40',
    ButtonPrimaryToggleBorderDisabled: 'SystemBlue10',
    ButtonPrimaryToggleForeground: 'SystemBlue70',
    ButtonPrimaryToggleForegroundHovered: 'SystemBlue70',
    ButtonPrimaryToggleForegroundPressed: 'SystemBlue70',
    ButtonPrimaryToggleForegroundDisabled: 'SystemBlue30',
    ButtonPrimaryToggleBackgroundOff: 'SystemWhite',
    ButtonPrimaryToggleBackgroundOffHovered: 'SystemGrey0',
    ButtonPrimaryToggleBackgroundOffPressed: 'SystemGrey5',
    ButtonPrimaryToggleBackgroundOffDisabled: 'SystemWhite',
    ButtonPrimaryToggleBorderOff: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffHovered: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffPressed: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffDisabled: 'SystemGrey0',
    ButtonPrimaryToggleForegroundOff: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffHovered: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffPressed: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffDisabled: 'SystemGrey30',
    ButtonTertiaryBackground: 'SystemGrey5',
    ButtonTertiaryBackgroundHovered: 'SystemGrey20',
    ButtonTertiaryBackgroundPressed: 'SystemGrey20',
    ButtonTertiaryForeground: 'SystemBlack',
    ButtonTertiaryToggleBackground: 'SystemBlack',
    ButtonTertiaryToggleBackgroundHovered: 'SystemGrey70',
    ButtonTertiaryToggleBackgroundPressed: 'SystemGrey80',
    ButtonTertiaryToggleBackgroundDisabled: 'SystemGrey10',
    ButtonTertiaryToggleBorder: 'SystemBlack',
    ButtonTertiaryToggleBorderHovered: 'SystemGrey70',
    ButtonTertiaryToggleBorderPressed: 'SystemGrey80',
    ButtonTertiaryToggleBorderDisabled: 'SystemGrey10',
    ButtonTertiaryToggleForeground: 'SystemWhite',
    ButtonTertiaryToggleForegroundHovered: 'SystemWhite',
    ButtonTertiaryToggleForegroundPressed: 'SystemWhite',
    ButtonTertiaryToggleForegroundDisabled: 'SystemGrey40',
    ButtonTertiaryToggleBackgroundOff: 'SystemWhite',
    ButtonTertiaryToggleBackgroundOffHovered: 'SystemGrey10',
    ButtonTertiaryToggleBackgroundOffPressed: 'SystemGrey5',
    ButtonTertiaryToggleBackgroundOffDisabled: 'SystemGrey0',
    ButtonTertiaryToggleBorderOff: 'SystemBlack',
    ButtonTertiaryToggleBorderOffHovered: 'SystemGrey70',
    ButtonTertiaryToggleBorderOffPressed: 'SystemGrey80',
    ButtonTertiaryToggleBorderOffDisabled: 'SystemGrey30',
    ButtonTertiaryToggleForegroundOff: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffHovered: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffPressed: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffDisabled: 'SystemGrey30',
    ListCellIconToggledOn: 'SystemBlue60',
    LoadingDefault: 'SystemBlue60',
    OverlayLoadingDefault: 'SystemBlue60',
    PaginationSelectedPrimary: 'SystemBlue60',
    TextAction: 'SystemBlue60',
    TextCallout: 'SystemBlue60',
    TextSelected: 'SystemBlue60'
  }
};